<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83784 12C5.83784 8.59671 8.59671 5.83784 12 5.83784C15.4033 5.83784 18.1622 8.59671 18.1622 12C18.1622 15.4033 15.4033 18.1622 12 18.1622C8.59671 18.1622 5.83784 15.4033 5.83784 12ZM12 16C9.79085 16 8 14.2092 8 12C8 9.79085 9.79085 8 12 8C14.2091 8 16 9.79085 16 12C16 14.2092 14.2091 16 12 16Z"
      fill="url(#paint0_linear_2456_5289)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83784 12C5.83784 8.59671 8.59671 5.83784 12 5.83784C15.4033 5.83784 18.1622 8.59671 18.1622 12C18.1622 15.4033 15.4033 18.1622 12 18.1622C8.59671 18.1622 5.83784 15.4033 5.83784 12ZM12 16C9.79085 16 8 14.2092 8 12C8 9.79085 9.79085 8 12 8C14.2091 8 16 9.79085 16 12C16 14.2092 14.2091 16 12 16Z"
      fill="url(#paint1_radial_2456_5289)"
    />
    <path
      d="M18.4056 7.03436C19.2009 7.03436 19.8456 6.38968 19.8456 5.59438C19.8456 4.79909 19.2009 4.15436 18.4056 4.15436C17.6104 4.15436 16.9656 4.79909 16.9656 5.59438C16.9656 6.38968 17.6104 7.03436 18.4056 7.03436Z"
      fill="url(#paint2_linear_2456_5289)"
    />
    <path
      d="M18.4056 7.03436C19.2009 7.03436 19.8456 6.38968 19.8456 5.59438C19.8456 4.79909 19.2009 4.15436 18.4056 4.15436C17.6104 4.15436 16.9656 4.79909 16.9656 5.59438C16.9656 6.38968 17.6104 7.03436 18.4056 7.03436Z"
      fill="url(#paint3_radial_2456_5289)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0C8.741 0 8.33234 0.0138139 7.05242 0.0722133C5.77516 0.13047 4.90283 0.333343 4.13954 0.630008C3.35044 0.936629 2.68123 1.34695 2.01406 2.01406C1.34695 2.68123 0.936629 3.35044 0.630008 4.13954C0.333343 4.90283 0.13047 5.77516 0.0722133 7.05242C0.0138139 8.33234 0 8.741 0 12C0 15.259 0.0138139 15.6677 0.0722133 16.9476C0.13047 18.2248 0.333343 19.0972 0.630008 19.8605C0.936629 20.6496 1.34695 21.3188 2.01406 21.9859C2.68123 22.6531 3.35044 23.0634 4.13954 23.37C4.90283 23.6667 5.77516 23.8695 7.05242 23.9278C8.33234 23.9862 8.741 24 12 24C15.259 24 15.6677 23.9862 16.9476 23.9278C18.2248 23.8695 19.0972 23.6667 19.8605 23.37C20.6496 23.0634 21.3188 22.6531 21.9859 21.9859C22.6531 21.3188 23.0634 20.6496 23.37 19.8605C23.6667 19.0972 23.8695 18.2248 23.9278 16.9476C23.9862 15.6677 24 15.259 24 12C24 8.741 23.9862 8.33234 23.9278 7.05242C23.8695 5.77516 23.6667 4.90283 23.37 4.13954C23.0634 3.35044 22.6531 2.68123 21.9859 2.01406C21.3188 1.34695 20.6496 0.936629 19.8605 0.630008C19.0972 0.333343 18.2248 0.13047 16.9476 0.0722133C15.6677 0.0138139 15.259 0 12 0ZM12 2.16216C15.2041 2.16216 15.5837 2.1744 16.849 2.23213C18.019 2.28548 18.6544 2.48097 19.0773 2.64531C19.6374 2.863 20.0371 3.12303 20.457 3.54297C20.877 3.96287 21.137 4.36261 21.3547 4.92274C21.519 5.34559 21.7145 5.98098 21.7679 7.15097C21.8256 8.41632 21.8378 8.79587 21.8378 12C21.8378 15.2041 21.8256 15.5837 21.7679 16.849C21.7145 18.019 21.519 18.6544 21.3547 19.0773C21.137 19.6374 20.877 20.0371 20.457 20.457C20.0371 20.877 19.6374 21.137 19.0773 21.3547C18.6544 21.519 18.019 21.7145 16.849 21.7679C15.5839 21.8256 15.2044 21.8378 12 21.8378C8.79564 21.8378 8.41618 21.8256 7.15097 21.7679C5.98098 21.7145 5.34559 21.519 4.92275 21.3547C4.36262 21.137 3.96287 20.877 3.54298 20.457C3.12308 20.0371 2.863 19.6374 2.64531 19.0773C2.48098 18.6544 2.28549 18.019 2.23214 16.849C2.1744 15.5837 2.16216 15.2041 2.16216 12C2.16216 8.79587 2.1744 8.41632 2.23214 7.15097C2.28549 5.98098 2.48098 5.34559 2.64531 4.92274C2.863 4.36261 3.12304 3.96287 3.54298 3.54297C3.96287 3.12303 4.36262 2.863 4.92275 2.64531C5.34559 2.48097 5.98098 2.28548 7.15097 2.23213C8.41632 2.1744 8.79587 2.16216 12 2.16216Z"
      fill="url(#paint4_linear_2456_5289)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 0C8.741 0 8.33234 0.0138139 7.05242 0.0722133C5.77516 0.13047 4.90283 0.333343 4.13954 0.630008C3.35044 0.936629 2.68123 1.34695 2.01406 2.01406C1.34695 2.68123 0.936629 3.35044 0.630008 4.13954C0.333343 4.90283 0.13047 5.77516 0.0722133 7.05242C0.0138139 8.33234 0 8.741 0 12C0 15.259 0.0138139 15.6677 0.0722133 16.9476C0.13047 18.2248 0.333343 19.0972 0.630008 19.8605C0.936629 20.6496 1.34695 21.3188 2.01406 21.9859C2.68123 22.6531 3.35044 23.0634 4.13954 23.37C4.90283 23.6667 5.77516 23.8695 7.05242 23.9278C8.33234 23.9862 8.741 24 12 24C15.259 24 15.6677 23.9862 16.9476 23.9278C18.2248 23.8695 19.0972 23.6667 19.8605 23.37C20.6496 23.0634 21.3188 22.6531 21.9859 21.9859C22.6531 21.3188 23.0634 20.6496 23.37 19.8605C23.6667 19.0972 23.8695 18.2248 23.9278 16.9476C23.9862 15.6677 24 15.259 24 12C24 8.741 23.9862 8.33234 23.9278 7.05242C23.8695 5.77516 23.6667 4.90283 23.37 4.13954C23.0634 3.35044 22.6531 2.68123 21.9859 2.01406C21.3188 1.34695 20.6496 0.936629 19.8605 0.630008C19.0972 0.333343 18.2248 0.13047 16.9476 0.0722133C15.6677 0.0138139 15.259 0 12 0ZM12 2.16216C15.2041 2.16216 15.5837 2.1744 16.849 2.23213C18.019 2.28548 18.6544 2.48097 19.0773 2.64531C19.6374 2.863 20.0371 3.12303 20.457 3.54297C20.877 3.96287 21.137 4.36261 21.3547 4.92274C21.519 5.34559 21.7145 5.98098 21.7679 7.15097C21.8256 8.41632 21.8378 8.79587 21.8378 12C21.8378 15.2041 21.8256 15.5837 21.7679 16.849C21.7145 18.019 21.519 18.6544 21.3547 19.0773C21.137 19.6374 20.877 20.0371 20.457 20.457C20.0371 20.877 19.6374 21.137 19.0773 21.3547C18.6544 21.519 18.019 21.7145 16.849 21.7679C15.5839 21.8256 15.2044 21.8378 12 21.8378C8.79564 21.8378 8.41618 21.8256 7.15097 21.7679C5.98098 21.7145 5.34559 21.519 4.92275 21.3547C4.36262 21.137 3.96287 20.877 3.54298 20.457C3.12308 20.0371 2.863 19.6374 2.64531 19.0773C2.48098 18.6544 2.28549 18.019 2.23214 16.849C2.1744 15.5837 2.16216 15.2041 2.16216 12C2.16216 8.79587 2.1744 8.41632 2.23214 7.15097C2.28549 5.98098 2.48098 5.34559 2.64531 4.92274C2.863 4.36261 3.12304 3.96287 3.54298 3.54297C3.96287 3.12303 4.36262 2.863 4.92275 2.64531C5.34559 2.48097 5.98098 2.28548 7.15097 2.23213C8.41632 2.1744 8.79587 2.16216 12 2.16216Z"
      fill="url(#paint5_radial_2456_5289)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2456_5289"
        x1="1.40032"
        y1="1.26175"
        x2="8.96732"
        y2="30.5318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4E60D3" />
        <stop offset="0.142763" stop-color="#913BAF" />
        <stop offset="0.761458" stop-color="#D52D88" />
        <stop offset="1" stop-color="#F26D4F" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_2456_5289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.26584 24) rotate(32.1601) scale(22.4147 16.1312)"
      >
        <stop stop-color="#FED276" />
        <stop offset="0.17024" stop-color="#FDBD61" stop-opacity="0.975006" />
        <stop offset="0.454081" stop-color="#F6804D" />
        <stop offset="1" stop-color="#E83D5C" stop-opacity="0.01" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_2456_5289"
        x1="1.40032"
        y1="1.26175"
        x2="8.96732"
        y2="30.5318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4E60D3" />
        <stop offset="0.142763" stop-color="#913BAF" />
        <stop offset="0.761458" stop-color="#D52D88" />
        <stop offset="1" stop-color="#F26D4F" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_2456_5289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.26584 24) rotate(32.1601) scale(22.4147 16.1312)"
      >
        <stop stop-color="#FED276" />
        <stop offset="0.17024" stop-color="#FDBD61" stop-opacity="0.975006" />
        <stop offset="0.454081" stop-color="#F6804D" />
        <stop offset="1" stop-color="#E83D5C" stop-opacity="0.01" />
      </radialGradient>
      <linearGradient
        id="paint4_linear_2456_5289"
        x1="1.40032"
        y1="1.26175"
        x2="8.96732"
        y2="30.5318"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4E60D3" />
        <stop offset="0.142763" stop-color="#913BAF" />
        <stop offset="0.761458" stop-color="#D52D88" />
        <stop offset="1" stop-color="#F26D4F" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_2456_5289"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(7.26584 24) rotate(32.1601) scale(22.4147 16.1312)"
      >
        <stop stop-color="#FED276" />
        <stop offset="0.17024" stop-color="#FDBD61" stop-opacity="0.975006" />
        <stop offset="0.454081" stop-color="#F6804D" />
        <stop offset="1" stop-color="#E83D5C" stop-opacity="0.01" />
      </radialGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Instagram',
};
</script>
